<template>
  <header>
    <div class="header-wrapper">
      <div class="logo-header">
        <img alt="Foto Urbana Logo" src="../assets/logo-fotourbana.svg">
        <div class="logo-text">
          <router-link to="/">
          {{ title }}
          </router-link>
        </div>
      </div>
      <Navigation v-if="!mobileView" />
      <div class="res-menu">
        <i class="fas fa-bars" v-if="mobileView" @click="showNav=!showNav"></i>
      </div>
      <div :class="{'open':showNav}" class="navMob">
        <div id="myNav" class="overlay">
          <a href="#" class="closeBtn" @click="showNav=!showNav">&times;</a>
          <div class="overlay-content-container">
            <div class="overlay-content">
              <div class="logo-header">
                <img class="home-logo logo-mobile" src="../assets/logo-fotourbana.svg">
              </div>
              <AppDropdown v-for="item in navItems.items" :key="item.name">
                <template slot="toggler">
                  <div v-if="item.title=='Autores'">
                    <a :href="`/c/${item.slug}`" class="menu-link">
                      {{item.title}}
                    </a>
                  </div>
                  <div v-if="item.title!=='Autores'">
                    <a href="#" class="menu-link">{{item.title}}
                      <span v-if="item.child_items" class="afu-btn">
                        <i class="fas fa-caret-down"></i>
                      </span>
                    </a>
                  </div>
                </template>
                <DropdownContent>
                  <li v-for="childItem in item.child_items" :key="childItem.ID">
                    <a v-if="childItem.object==='category'" :href="`/c/${childItem.slug}`">{{ childItem.title }}</a>
                    <a v-if="childItem.object==='page'" :href="`/p/${childItem.slug}`">{{ childItem.title }}</a>
                  </li>
                </DropdownContent>
              </AppDropdown>
              <div class="social-buttons-mobile">
                <a href="https://www.facebook.com/fotourbanaorg"><i class="fab fa-facebook-square" /></a>
                <a href="https://www.instagram.com/fotourbanaorg/"><i class="fab fa-instagram" /></a>
                <a href="https://twitter.com/fotourbanaorg"><i class="fab fa-twitter" /></a>
                <a href="https://www.youtube.com/channel/UCGPn3PDaWP5Z8tNaUWAo1PA"><i class="fab fa-youtube" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import axios from 'axios'
import Navigation from './navigation/Navigation'
import DropdownContent from './navigation/DropdownContent'
import AppDropdown from './navigation/AppDropdown'


export default {
  components: {
    Navigation,
    DropdownContent,
    AppDropdown
  },
  props: {
    title: {
      type: String,
      default: 'Título'
    }
  },
  data: () => {
    return {
      mobileView: true,
      showNav: false,
      navItems: [],
      active: false
    }
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth < 1150;
    },
    getMenuItems() {
      axios.get('https://foto-urbana.credopop.com/wp-json/menus/v1/menus/primary-menu')
      .then(response => {
        this.navItems = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    toggle () {
      this.active = !this.active
    }
  },
  created() {
    this.handleView()
    this.getMenuItems()
 },
}
</script>
<style scoped>
a,
a:link,
a:visited,
a:active {
  color: #000000;
  opacity: 1.0;
  text-decoration: none;
}

a:hover {
  color: #000000;
  opacity: 1;
  text-decoration: none;
}
a.closeBtn {
    position: absolute;
    top: 20px;
    right: 45px;
    font-size: 60px;
    font-weight: bold;
    color: #000000;
    text-decoration: none;
    font-family: 'Raleway', sans-serif;
    z-index: 999999999999999;
}
a.closeBtn:active,
a.closeBtn:visited {
  color: #000000;
  opacity: 1;
}
header {
  height: 75px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px #c4c4c4;
  padding: 10px;
  z-index: 99;
  display: flex;
  justify-content: center;
}
.header-wrapper {
  max-width: 1320px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  position: relative;
}
.logo-text {
  width: 200px;
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: left;
  padding-left: 10px;
  margin-top: 15px;
  vertical-align: middle;
}
.logo-header {
  display: flex;
  flex-direction: row;
}
.search i {
  position: absolute;
  vertical-align: middle;
  font-size: 18px;
  right: 0;
  top: -5px;
}
.search {
  position: relative;
  cursor: pointer;
}
.search input {
  width: 30px;
  height: 20px;
  border: none;
  box-sizing: border-box;
  font-family: Raleway;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  margin-left: 20px;
  padding-left: 10px;
}
::placeholder {
  color: #888888;
}
input:focus {
  border: none;
}
.menu {
  font-family: Raleway;
  position: relative;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.menu-item {
  float: left;
  padding-left: 20px;
  font-size: 14px;
  color: #000000;
  height: 50px;
  margin-top: 50px;
}
.menu-link {
  opacity: 1;
  transition: all 0.3s ease-in-out;
  color: #000000;
  text-decoration: none;
  padding: 5px;
}
.menu-link:hover,
.menu-link:active,
.menu-link:visited {
  color: #000000;
  opacity: 1;
  background-image: url('../assets/focus.svg');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
  transition: all .1s ease-out;
}
.menu-item a {
  z-index: 100;
}
.menu-item span {
  z-index: -1;
}
.menu-link:hover:before  {
  background: #000;
  width: 10px;
  height: 10px;
}
ul {
  list-style-type: none;
}
.afu-dropdown-content {
  display: none;
  position: absolute;
  left:-150%;
  background-color: #e5e5e5;
  padding: 25px 50px;
  min-width: 120px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 20%);
  width: 1280px;
  margin-top: 20px;
  transition: all .5s ease-in;
  z-index: 100000;
}
.afu-dropdown-content a {
  color: #000;
  text-decoration: none;
  padding: 5px;
}
.afu-dropdown-content a:hover {
  background-image: url('../assets/focus-blanco.svg');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
  transition: all .1s ease-out;
}
.menu-item.dropdown:hover>.afu-dropdown-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  transition: all .8s ease-in;
}
@media(max-width: 1255px) {
  .logo-text {
    margin-top: 5px;
  }
}
@media only screen and (max-width: 1150px) {
  .res-menu {
      display: inline;
      font-size: 30px;
      padding-top: 5px;
      cursor: pointer;
  }
  .header-wrapper {
    justify-content: space-between;
  }
}
</style>
